<template>
    <div class="box">
      <div class="team">
        <img :src="imgView(team.badge)" />
        <div class="team-detail">
          <h4>{{ team.name }}</h4>
          <div>{{ team.location }}</div>
        </div>
      </div>
      <div class="officers">
        <div class="officer" style="width: 30%;" v-if="leader !== ''">领队：{{ leader }}</div>
        <div v-else></div>
        <div class="officer" style="width: 50%;" v-if="coach !== ''">教练：{{ coach }}</div>
        <div v-else></div>
      </div>
      <div class="title">{{ $t('attendMatchPlayer.text_1') }}</div>
      <div class="main">
        <div class="item" v-for="item in players" :key="item.id">
          <img :src="imgView(item.photo)" v-if="item.photo" />
          <div class="player-detail">
            <div class="info">
              <h4>{{ item.trueName }}</h4>
              <span v-if="item.number && item.number >= 0">{{ item.number }}号</span>
            </div>
            <div class="position">{{ item.position }}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getBMPlayerList } from '@/api/match'
import { QNImageUtil } from '@/utils'
export default {
  data() {
    return {
      matchId: '',
      teamId: '',
      team: {},
      players: [],
      leader: '',
      coach: ''
    };
  },
  created() {
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.getBMPlayerList()
  },
  methods: {
    getBMPlayerList() {
      getBMPlayerList({ teamId: this.teamId, matchId: this.matchId }).then(res => {
        const data = res.data
        this.players = data.players
        this.team = data.team
        const officers = data.offices || []
        const ls = []
        const cs = []
        officers.forEach(o => {
          if (o.role === '领队') {
            ls.push(o.trueName)
          } else if (o.role === '教练') {
            cs.push(o.trueName)
          }
        })
        this.leader = ls.join('、')
        this.coach = cs.join('、')
      })
    },
    imgView(img) {
      if(!img) return 'https://www.snsports.cn/webapp-stage/images/Mensingles.png'
      return QNImageUtil.imageView(img)
    }
  },
};
</script>

<style scoped lang="scss">
.box{
  min-height: 100vh;
  background-color: #F8F8F8;
  .team{
    height: 76px;
    padding: 15px;
    background: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    img{
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
    .team-detail{
      h4{
        margin: 0;
        margin-bottom: 7px;
      }
      div{
        font-size: 12px;
        color: #9B9B9B;
      }
    }
  }
  .officers {
    padding: 2px 15px 8px 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    font-size: 13px;
    color: #333333;
    .officer {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .title{
    color: #9B9B9B;
    font-size: 14px;
    background: #F8F8F8;
    padding: 10px 15px;
  }
  .main{
    .item{
      padding: 15px;
      padding-right: 0px;
      background: #fff;
      display: flex;
      img{
        width: 50px;
        // height: 50px;
        margin-right: 10px;
        // border-radius: 50px;
      }
      .player-detail{
        flex: 1;
        border-bottom: 1px solid #F2F2F2;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .info{
        padding-bottom: 10px;
        h4{
          margin: 0;
          color: #191919;
          font-size: 16px;
          margin-top: 2px;
          font-weight: 400;
          margin-bottom: 10px;
        }
        span{
          color: #9B9B9B;
          font-size: 12px;
        }
      }
      .position{
        color: #9B9B9B;
        font-size: 12px;
        padding-right: 15px;
      }
    }
  }
}
</style>
